import React from 'react';
import { Button } from './ui/Button';
import { Download } from 'lucide-react';
export function PricingCard() {
  return <section id="pricing" className="py-24 bg-slate-950 relative overflow-hidden" data-id="element-113">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-114" />

      <div className="container mx-auto px-4 max-w-lg relative z-10" data-id="element-115">
        <div className="bg-slate-900 rounded-3xl p-8 md:p-10 border border-slate-800 shadow-2xl shadow-black" data-id="element-116">
          <div className="text-center mb-8" data-id="element-117">
            <span className="inline-block px-4 py-1 rounded-full bg-amber-500/10 text-amber-400 text-sm font-bold mb-4 border border-amber-500/20" data-id="element-118">
              OFERTA ESPECIAL
            </span>
            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-119">
              Protocolo Noche Tranquila 65+
            </h2>
            <p className="text-slate-400" data-id="element-120">
              PDF Digital + Imprimibles + Guía de Audio
            </p>
          </div>

          <div className="flex flex-col items-center mb-8" data-id="element-121">
            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-122">
              <span className="text-2xl text-slate-500 line-through" data-id="element-123">$19</span>
              <span className="text-5xl font-bold text-amber-400" data-id="element-124">$6.39</span>
              <span className="text-xl text-slate-500 ml-1" data-id="element-125">USD</span>
            </div>
            <span className="inline-block px-3 py-1 rounded-full bg-green-500/15 text-green-400 text-sm font-bold border border-green-500/20" data-id="element-126">
              Ahorras 66% — Descuento por tiempo limitado
            </span>
          </div>

          <div className="space-y-4" data-id="element-127">
            <Button fullWidth size="lg" className="text-lg font-bold h-16 shadow-amber-500/20" onClick={() => window.open('https://www.serenahora.com/cart/54736550560035:1', '_blank')} data-id="element-128">
              Descargar Protocolo Ahora
              <Download className="ml-2 w-5 h-5" data-id="element-129" />
            </Button>
            <p className="text-center text-xs text-slate-500" data-id="element-130">
              Pago seguro • Entrega inmediata por email
            </p>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-131">
          <p className="text-xl font-medium text-slate-300 italic" data-id="element-132">
            "Cambia 'otra noche horrible' por 'ya sé qué hacer'."
          </p>
        </div>
      </div>
    </section>;
}